export default __webpack_public_path__ + "static/media/img_18.f6aa6f66.jpg";